/**
 * Helpers de validation RH pour la saisie mensuelle (A-06).
 * Statuts persistés avec la ligne ; la génération de paie est bloquée
 * tant qu’une ligne sensible n’est pas « approuve ».
 */
import type { LigneSaisieMensuelle } from './ElementsVariables';
import { exigeValidationRh } from './ElementsVariables';

export type StatutValidationRh = 'ok' | 'a_controler' | 'approuve' | 'refuse';

export interface LigneSaisieAvecValidation extends LigneSaisieMensuelle {
  validation_rh?: StatutValidationRh;
}

/** Calcule le statut affiché / à persister pour une ligne. */
export function calculerStatutValidationRh(
  ligne: LigneSaisieAvecValidation,
  salaireFiche: number,
): StatutValidationRh {
  if (!exigeValidationRh(ligne, salaireFiche)) return 'ok';
  if (ligne.validation_rh === 'approuve' || ligne.validation_rh === 'refuse') {
    return ligne.validation_rh;
  }
  return 'a_controler';
}

/** true si la génération de bulletin est autorisée pour cette ligne. */
export function peutGenererBulletin(
  ligne: LigneSaisieAvecValidation,
  salaireFiche: number,
): boolean {
  const statut = calculerStatutValidationRh(ligne, salaireFiche);
  return statut === 'ok' || statut === 'approuve';
}

/** true si au moins une ligne bloque le lot. */
export function bloquerGenerationLot(
  lignes: readonly { ligne: LigneSaisieAvecValidation; salaireFiche: number }[],
): string | null {
  for (const { ligne, salaireFiche } of lignes) {
    if (!peutGenererBulletin(ligne, salaireFiche)) {
      return `${ligne.matricule} : validation RH requise (salaire modifié ou prime extraordinaire)`;
    }
  }
  return null;
}

export function libelleStatutValidationRh(statut: StatutValidationRh): string {
  switch (statut) {
    case 'ok':
      return 'OK';
    case 'a_controler':
      return 'À contrôler';
    case 'approuve':
      return 'Approuvé';
    case 'refuse':
      return 'Refusé';
  }
}
